import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { DialogObject } from './dialog.types';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'sm-dialog',
  imports: [DialogModule, ButtonModule, CommonModule, TranslateModule],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
})
export class DialogComponent {
  @Input() dialog?: DialogObject = {
    title: '',
    description: '',
  };

  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  handleActionClick(action: any) {
    if (action.onClick) {
      action.onClick();
    }
  }

  toggleVisible() {
    this.visible = !this.visible;
    this.visibleChange.emit(this.visible);
  }
}
